import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import * as fromManageUsers from './';

export const ManageUsersRoute: Ng2StateDeclaration = {
    // name: 'manageusers.**'
    name: 'manageusers',
    url: '/manageusers',
    // , loadChildren: () => import('./manage-users.module').then(r => r.ManageUsersModule)
    data: { requiresAuth: true },
    params: { process: {} },
    component: fromManageUsers.ManageUsersContainerComponent
};
